import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import Crumb, { CrumbTemplateProps } from '../Crumb';

export default function LotOverviewCrumb({ current }: CrumbTemplateProps) {
  return <Crumb current={current} text={t(TranslationKey.lot).plural.upper} path={Routing.stock.lots.overview()} />;
}
